import { X, AlertTriangle, Snowflake, Ghost } from "lucide-react";

const PROBLEMS = [
  {
    icon: Snowflake,
    title: "Bare paint gets eaten alive by road salt",
    desc: "The moment plows drop their first load, Mississauga roads turn into a corrosion bath. Uncoated clearcoat pulls salt into every micro-scratch and fades, spiders, and rusts by March. By spring your paint looks a full year older.",
  },
  {
    icon: X,
    title: "The $200 spray-on ceramic lie",
    desc: "Cheap detail bays sell winter ceramic packages that are really $30-a-bottle spray sealants. They wash off in 3 to 5 washes. First salt storm and it is gone. You paid a coating price and walked out with a wax that dies before Christmas.",
  },
  {
    icon: AlertTriangle,
    title: "Single-layer coatings that peel by February",
    desc: "Mid-tier shops brush one thin layer of low-grade coating on and call it 5-year protection. Ontario road salt and freeze-thaw cycles chew through it in 90 days. Come spring you are back to bird droppings eating your clearcoat.",
  },
  {
    icon: Ghost,
    title: "Ghost warranty when spring reveals the damage",
    desc: "\"5-year warranty\" with zero paperwork is marketing, not accountability. When April thaw exposes the etching and rust spots, the number stops answering. No before-after photos, no records, no recourse. You wear the salt damage alone.",
  },
];

export default function ProblemAgitation() {
  return (
    <section
      className="relative py-24 md:py-32 bg-[#120127] border-t border-white/5"
      data-testid="problem-agitation-section"
    >
      <div className="absolute -top-20 right-1/3 w-[500px] h-[500px] rounded-full bg-red-500/8 blur-[140px]" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-red-400 mb-5 font-label">
            What Ontario Winter Actually Does
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
            Every unprotected<br />
            <span className="text-jester">clearcoat in the GTA</span><br />
            loses this winter.
          </h2>
          <p className="mt-6 text-white/75 text-lg leading-relaxed">
            Between November and April, Mississauga roads get hit with over
            140,000 tonnes of salt. Add freeze-thaw cycles, magnesium chloride,
            sand and slush. This is what happens to bare paint and to the
            cheap coatings pretending to protect it.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {PROBLEMS.map((p, i) => {
            const Icon = p.icon;
            return (
              <article
                key={i}
                className="relative p-7 rounded-2xl border border-red-500/20 bg-gradient-to-br from-red-500/[0.04] to-transparent backdrop-blur-sm"
                data-testid={`problem-card-${i}`}
              >
                <div className="w-12 h-12 rounded-full bg-red-500/15 border border-red-400/30 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-red-400" />
                </div>
                <h3 className="font-display text-2xl text-white mb-3 leading-tight">
                  {p.title}
                </h3>
                <p className="text-white/70 text-[15px] leading-relaxed">
                  {p.desc}
                </p>
              </article>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <p className="font-marker text-acid text-2xl md:text-3xl">
            we shut all four out. below.
          </p>
        </div>
      </div>
    </section>
  );
}
